import categoriesService from '../../services/categories'

const state = {
  categories: []
}

// getters
const getters = {
  getCategoryIndex: (state) => (categoryId) => {
    return state.categories
                .findIndex(category => category.categoryId === categoryId);
  },
  getCategoryById: (state) => (categoryId) => {
    return state.categories
                .find(category => category.categoryId === categoryId);
  }
}

// actions
const actions = {
  async getCategoriesAction(context) {
    await categoriesService.getCategoriesByRestaurant()
                            .then( data => 
                              { context.commit('setCategoriesState', data) });  
  },
  async addCategoryAction(context, category) {
    await categoriesService.createCategory(category);
    context.commit('addCategoryState', category);
  }, 
  async updateCategoryAction(context, category) {
    await categoriesService.updateCategory(category);
    context.commit('updateCategoryState', category);
                           
  },
  async deleteCategoryAction(context, category) {
    await categoriesService.deleteCategory(category.categoryId);
    context.commit('deleteCategoryState', category);
  }
}

// mutations
const mutations = {
  setCategoriesState(state, categories) {
    state.categories = categories;
  },
  addCategoryState(state, category) {
    state.categories.push(category);
  },
  updateCategoryState(state, category) {
    let index = state.categories
                                .findIndex(c => c.categoryId === category.categoryId);
    if (index > -1) {
      state.categories[index] = category;
    }
  },
  deleteCategoryState(state, category) {
    let index = state.categories
                     .findIndex(c => c.categoryId === category.categoryId);
    if(index > -1) {
      state.categories.splice(index, 1);
    }
  },
  update(state, payload) {
    
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}